exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#alinear {\n  text-align: justify;\n}\n", ""]);

// exports
